
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import { getBlocksFromWordPress } from "@/lib/global-blocks/global-blocks";
import { configStore } from "@/store/store";
import { getDocumentUrlFromId } from "@/lib/wordpress/load";
import { pipe } from "fp-ts/lib/function";
import { fold } from "fp-ts/lib/Either";
import NotificationLogger from "@/lib/notifications/notifications";

@Component({
  components: { Icon }
})
export default class GlobalBlockInput extends Vue {
  @Prop()
  value: number | undefined;

  loading = false;
  async mounted() {
    this.loading = true;
    pipe(
      await getBlocksFromWordPress(),
      fold(
        errors => errors.forEach(e => NotificationLogger.log.message(e.msg)),
        configStore.setGlobalBlocks
      )
    );
    this.loading = false;
  }

  get allBlocks() {
    return configStore.globalBlocks.filter(b => b.tree !== false);
  }

  get items() {
    return this.allBlocks.map(globalBlock => {
      return {
        text: globalBlock.label,
        value: globalBlock.id
      };
    });
  }

  get getBlockDocumentHref() {
    if (!this.value) return false;

    return getDocumentUrlFromId(this.value);
  }

  edit(string: unknown) {
    if (!string) {
      // eslint-disable-next-line no-param-reassign
      string = "";
    }
    this.$emit("input", string);
  }
}
